module.exports = __webpack_public_path__ + "static/media/07LoganBrothersHaywoodRdmuraldetail.1586bfc7.webp";